import React from 'react';

import { Flex, Progress, useTheme } from '@chakra-ui/react';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import styled from 'styled-components';
import { StyledBorderedPaper } from 'styles/common';

import { StyledIcon, UncheckedCircle } from 'constants/icons';
import muiTheme from 'constants/theme';
import theme from 'constants/theme';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { BulkUploadDownloadButton } from './BulkUploadDownloadButton';

const INVALID_CSV_ERROR = 'The data in the CSV was not valid, please download the file to see specific errors';

const StyledInfoIcon = styled(InfoOutlinedIcon)`
  margin-right: 2px;
`;
const BulkUploadCardBody = ({ type, value, recordsUpdated, totalRecords, fileName = '', uuid }) => {
  const theme = useTheme();

  if (type === 'IN_PROGRESS') {
    return (
      <Flex flexDirection="column" color={theme.colors.text.g1}>
        <TextBodyMedium sx={{ margin: '0' }}>{fileName}</TextBodyMedium>
        <Flex flexDirection="column">
          <TextBodyMedium color={theme.colors.text.g2} sx={{ margin: '8px 0' }}>
            Uploading : {recordsUpdated} of {totalRecords}
          </TextBodyMedium>
          <Progress
            sx={{
              borderRadius: '8px',
              width: '100%',
              height: '6px',
              div: {
                backgroundColor: theme.colors.brand.blue,
              },
            }}
            value={value}
            isAnimated
          />
        </Flex>
      </Flex>
    );
  }
  if (type === 'VALIDATING') {
    return (
      <Flex flexDirection="column" color={theme.colors.text.g1}>
        <TextBodyMedium sx={{ margin: '0' }}>{fileName}</TextBodyMedium>
        <Flex flexDirection="column">
          <TextBodyMedium color={theme.colors.text.g2} sx={{ margin: '8px 0' }}>
            Validation in progress
          </TextBodyMedium>

          <Progress
            sx={{
              borderRadius: '8px',
              width: '100%',
              height: '6px',
              div: {
                backgroundColor: theme.colors.brand.blue,
              },
            }}
            isIndeterminate
          />
        </Flex>
      </Flex>
    );
  }
  if (type === 'FINISHED') {
    return (
      <Flex flexDirection="column" color={theme.colors.text.g1}>
        <TextBodyMedium sx={{ margin: '0' }}>{fileName}</TextBodyMedium>
        <Flex>
          <UncheckedCircle size="fixed20px" color={muiTheme.palette.icons.green} style={{ marginRight: '8px' }} />
          <TextBodyMedium color={muiTheme.palette.icons.green} sx={{ margin: '8px 0' }}>
            Successfully uploaded {recordsUpdated} of {totalRecords}
          </TextBodyMedium>
        </Flex>
      </Flex>
    );
  }

  if (type === 'ERROR') {
    const recordsLeft = totalRecords - recordsUpdated ?? 0;
    const isInvalidCSV = totalRecords === 0 && recordsUpdated === 0;
    return (
      <Flex flexDirection="column" color={theme.colors.text.g1}>
        <TextBodyMedium sx={{ margin: '0' }}>{fileName}</TextBodyMedium>
        <Flex>
          <StyledIcon size="fixed20px" color={muiTheme.palette.icons.red} style={{ marginRight: '8px' }}>
            <StyledInfoIcon />
          </StyledIcon>

          <TextBodyMedium color={muiTheme.palette.icons.red} sx={{ margin: '8px 0' }}>
            {isInvalidCSV ? (
              INVALID_CSV_ERROR
            ) : (
              <>
                Unable to upload {recordsLeft} of {totalRecords}, please download the file to see specific errors
              </>
            )}
          </TextBodyMedium>
        </Flex>
        <ButtonColorWrapper>
          <BulkUploadDownloadButton uuid={uuid} fileName={fileName} />
        </ButtonColorWrapper>
      </Flex>
    );
  }

  return null;
};

const BulkUploadCard = ({ recordsUpdated = 0, totalRecords = 0, type, fileName, uuid }) => {
  const value = (recordsUpdated / totalRecords) * 100;
  const theme = useTheme();

  return (
    <StyledBorderedPaper style={{ padding: '16px', marginTop: '16px' }}>
      <BulkUploadCardBody
        recordsUpdated={recordsUpdated}
        totalRecords={totalRecords}
        type={type}
        value={value}
        fileName={fileName}
        uuid={uuid}
      />
    </StyledBorderedPaper>
  );
};

const ButtonColorWrapper = styled('div')`
  color: ${theme.palette.text.blue};
  margin-left: auto;
  p {
    color: ${theme.palette.text.blue} !important;
  }
  svg {
    color: ${theme.palette.text.blue} !important;
  }
`;

export { BulkUploadCard };
